"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { breakpointMap } from "../theme/base";
/**
 * Can't use the media queries from "base.mediaQueries" because of how matchMedia works
 * In order for the listener to trigger we need have have the media query with a range, e.g.
 * (min-width: 370px) and (max-width: 576px)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
 */
const mediaQueries = (() => {
  let prevMinWidth = 0;
  return Object.keys(breakpointMap).reduce((accum, size, index) => {
    // Largest size is just a min-width of second highest max-width
    if (index === Object.keys(breakpointMap).length - 1) {
      return {
        ...accum,
        [size]: `(min-width: ${prevMinWidth}px)`
      };
    }
    const minWidth = prevMinWidth;
    const breakpoint = breakpointMap[size];

    // Min width for next iteration
    prevMinWidth = breakpoint + 1;
    return {
      ...accum,
      [size]: `(min-width: ${minWidth}px) and (max-width: ${breakpoint}px)`
    };
  }, {});
})();
const getKey = size => `is${size.charAt(0).toUpperCase()}${size.slice(1)}`;

// const isWindowDefined = typeof window !== "undefined";

// This element causes an error: ReferenceError: isWindowDefined is not defined
const getInitialState = () => {
  if (typeof window !== "undefined") {
    return Object.keys(mediaQueries).reduce((accum, size) => {
      const key = getKey(size);
      // const value = isWindowDefined ? window.matchMedia(mediaQueries[size]).matches : false;
      // return { ...accum, [key]: value };
      const mql = window.matchMedia(mediaQueries[size] ?? "");
      return {
        ...accum,
        [key]: mql.matches
      };
    }, {});
  }
  return Object.keys(mediaQueries).reduce((accum, size, currentIndex) => {
    const key = getKey(size);
    return {
      ...accum,
      [key]: currentIndex === 0
    };
  }, {});
};
const useMatchBreakpoints = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getInitialState();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [state, setState] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handlers = Object.keys(mediaQueries).map(size => {
        const mql = window.matchMedia(mediaQueries[size] ?? "");
        const handler = matchMediaQuery => {
          const key = getKey(size);
          setState(prevState => ({
            ...prevState,
            [key]: matchMediaQuery.matches
          }));
        };
        if (mql.addEventListener) {
          mql.addEventListener("change", handler);
        }
        return () => {
          if (mql.removeEventListener) {
            mql.removeEventListener("change", handler);
          }
        };
      });
      return () => {
        handlers.forEach(_temp);
      };
    };
    t2 = [setState];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return state;
};
export default useMatchBreakpoints;
function _temp(unsubscribe) {
  unsubscribe();
}